import React, { Fragment, PureComponent } from "react";
import _ from "lodash";
import PropTypes from "prop-types";

import { paginateResults } from "../../../helpers/listHelpers";
import DataGridLoading from "./DataGridLoading";
import DataGridNoResult from "./DataGridNoResult";

class DataGrid extends PureComponent {
  static propTypes = {
    onChangePagination: PropTypes.func.isRequired,
    ColumnComponent: PropTypes.func,
    HeaderComponent: PropTypes.func,
    PaginationComponent: PropTypes.func,
    columnProps: PropTypes.object,
    currentPage: PropTypes.number,
    data: PropTypes.array,
    headerProps: PropTypes.object,
    isLoading: PropTypes.bool,
    itemsByPage: PropTypes.number,
    keyBy: PropTypes.string
  };

  static defaultProps = {
    ColumnComponent: null,
    HeaderComponent: null,
    PaginationComponent: null,
    columnProps: {},
    currentPage: 1,
    data: [],
    headerProps: {},
    isLoading: false,
    itemsByPage: 4,
    keyBy: "id"
  };

  get firstElement() {
    return (this.props.currentPage - 1) * this.props.itemsByPage;
  }

  get lastElement() {
    return this.props.currentPage * this.props.itemsByPage;
  }

  handleNextPage = dataCount => {
    if (this.lastElement < dataCount) {
      this.props.onChangePagination(this.props.currentPage + 1);
    }
  };

  handlePreviousPage = () => {
    if (this.props.currentPage !== 1) {
      this.props.onChangePagination(this.props.currentPage - 1);
    }
  };

  render() {
    const { HeaderComponent, PaginationComponent, ColumnComponent, data, keyBy } = this.props;
    const paginatedData = paginateResults(data, this.firstElement, this.lastElement);

    return (
      <Fragment>
        <section className="data-grid">
          {this.props.isLoading && <DataGridLoading />}

          {_.isEmpty(paginatedData) && !this.props.isLoading && <DataGridNoResult />}

          {!_.isEmpty(paginatedData) &&
            !this.props.isLoading && (
              <Fragment>
                <HeaderComponent {...this.props.headerProps} />
                {paginatedData.map(item => (
                  <ColumnComponent key={item[keyBy]} item={item} {...this.props.columnProps} />
                ))}
              </Fragment>
            )}
        </section>

        {!_.isEmpty(paginatedData) &&
          PaginationComponent && (
            <PaginationComponent
              currentPage={this.props.currentPage}
              dataCount={_.size(data)}
              firstElement={this.firstElement}
              lastElement={this.lastElement}
              onNextPageClick={this.handleNextPage}
              onPreviousPageClick={this.handlePreviousPage}
            />
          )}
      </Fragment>
    );
  }
}

export default DataGrid;



// WEBPACK FOOTER //
// ./src/components/Layout/DataGrid/DataGrid.js